import { media, styled, selectTheme, Typography } from '@creditas-ui/react';

export const HelpTextDesktop = styled(Typography)`
  display: none;

  ${media.up('3xl')} {
    display: inline-block;

    margin-left: ${selectTheme('spacingX.md')};
  }
`;

export const DesktopLogo = styled.img`
  display: none;

  ${media.up('3xl')} {
    display: inline-block;
  }
`;

export const Logo = styled.img`
  height: ${selectTheme('spacingY.3xl')};
  width: 86px;

  ${media.up('3xl')} {
    display: none;
  }
`;
